import { UangJalanReportStatus } from "../types/uangJalanReport";

export const REPORT_WORKFLOW_STEP_KEYS = [
  UangJalanReportStatus.OPEN,
  UangJalanReportStatus.IN_REVIEW,
  UangJalanReportStatus.REVISION_REQUIRED,
  UangJalanReportStatus.VERIFIED,
  UangJalanReportStatus.APPROVED,
] as const;

/** Map report status onto the linear workflow stepper key. */
export const getReportWorkflowStepKey = (status: UangJalanReportStatus | string): string => {
  if (status === UangJalanReportStatus.APPROVED_WITH_OVERRIDE) {
    return UangJalanReportStatus.APPROVED;
  }
  return status;
};

/** Workflow progress for report status (0–100). */
export const getReportStatusProgress = (status: UangJalanReportStatus | string): number => {
  switch (status) {
    case UangJalanReportStatus.OPEN:
      return 0;
    case UangJalanReportStatus.REVISION_REQUIRED:
      return 20;
    case UangJalanReportStatus.IN_REVIEW:
      return 40;
    case UangJalanReportStatus.VERIFIED:
      return 70;
    case UangJalanReportStatus.APPROVED:
    case UangJalanReportStatus.APPROVED_WITH_OVERRIDE:
      return 100;
    default:
      return 0;
  }
};
